module.exports = __webpack_public_path__ + "static/media/user_logo.e2ae3445.png";